import { render, staticRenderFns } from "./SliceLetterCampaign.vue?vue&type=template&id=068ad5c4&scoped=true"
import script from "./SliceLetterCampaign.vue?vue&type=script&lang=js"
export * from "./SliceLetterCampaign.vue?vue&type=script&lang=js"
import style0 from "./SliceLetterCampaign.vue?vue&type=style&index=0&id=068ad5c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068ad5c4",
  null
  
)

export default component.exports